import React,{ Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from 'axios';
import { updateEditProductDetail } from "../../../actions/products";
import { showToastMessage } from "../../../actions/toastmessage";
import config from '../../../../config/config';
import SectionLabel from "../GroupingContainers/SectionLabel";
import { useLayoutEffect } from "react";
import DeliverySlider from "./DeliverySlider";

/**
 * Enquiry Forms only use when sellOnline is false, 0 or null
 * @param - enquiryFormId - product enquiry form id or default form id gets from api
 */
const DeliveryProfileSection = (props) => {
    const { permissions={} } = props;
    let [deliveryIdPair, setDeliveryIdPair] = useState([]);
    let [showDelivSec, setDelivSlider] = useState(false);
    let [outletData, setOutletData] = useState([]);
    const [delivUpfrontData, setDelivUpfrontData] = useState([]);
    const [deliveryPermissions, setDeliveryPermissions] = useState(null);
    useEffect(() => {
        if(!deliveryPermissions) {
            let deliveryTimeBand = axios.get(`/marketplace/gis/getDeliveryTimeBand.service`);
            let deliveryProfile = axios.get(`/marketplace/gis/listAllDeliveryProfile.service`);
            const apis=[ deliveryTimeBand, deliveryProfile];
            Promise.allSettled(apis)
            .then(response => {
                let data = {
                    deliveryProfile: [],
                    isVolumetricWeightEnabled: false
                };
                if(response[0].status=="fulfilled" && response[0].value && response[0].value.data) {
                    data.isVolumetricWeightEnabled = true; //Hardcoded True as of now -> response[0].value.data["result"].isVolumetricWeightEnabled;
                    data.volumetricWeightType = response[0].value.data["result"].volumetricWeightType;
                }
                if(response[1].status=="fulfilled" && response[1].value && response[1].value.data) {
                    data.deliveryProfile = response[1].value.data["result"];
                }
                if(data.deliveryProfile?.length) {
                    setDeliveryPermissions({...data});
                }                 
            });
        }

        return () => {
            setDeliveryPermissions(null);
        }
        
    }, [])

    useEffect(() => {        
        if(deliveryPermissions && deliveryPermissions.deliveryProfile.length) {
            console.log('permission Delivery data ==>', deliveryPermissions.deliveryProfile);
            let delivProfiles = deliveryPermissions.deliveryProfile || [];
            let outletData = permissions?.outletData || [];
            let deliveryIdPair = {}, outletWiseDeliveryList = [];

            delivProfiles.map((ele, index) => {
                if (!deliveryIdPair[ele.outletId]) {
                    deliveryIdPair[ele.outletId] = {};
                }
                deliveryIdPair[ele.outletId][ele.profileName] = ele.profileId;
            })
            let initialDelivData = props.productData?.outletWiseDeliveryList;
            let delivData = [];
            let showDelivProfiles = false;
            setDeliveryIdPair(deliveryIdPair);
            outletData.map((outlet, indexOutlet) => {
                let temp = [];
                delivProfiles.map((ele, index) => {
                    if (ele.outletId == outlet.outletId) {
                        temp.push(ele.profileName);
                        if (initialDelivData && initialDelivData.length) {
                            if (initialDelivData[indexOutlet] && Number(initialDelivData[indexOutlet].deliveryProfileId) == ele.profileId)
                                outlet.selectedProfile = ele.profileName;
                        } else if (ele.isDefault) {
                            outlet.selectedProfile = ele.profileName;
                        }
                    }
                })
                if (initialDelivData && initialDelivData.length) {
                    delivData.push({
                        key: outlet.name,
                        value: outlet.selectedProfile
                    });
                }
                outlet.deliveryOptions = temp;
                if (!showDelivProfiles) {
                    showDelivProfiles = (temp.length > 1);
                }
                outletWiseDeliveryList.push({
                    outletId: outlet.outletId,
                    deliveryProfileId: deliveryIdPair[outlet.outletId][outlet.selectedProfile]
                })
            })
            setDelivUpfrontData(delivData);
            setOutletData(outletData);
            props.updateEditProductDetail([
                {
                    key: 'outletWiseDeliveryList',
                    value: outletWiseDeliveryList
                },
                {
                    key: 'accountMongoId',
                    value: outletData[0] ? outletData[0].id : ''
                }
            ]);
        }
    }, [deliveryPermissions]);

    const saveHandler = (data) => {

        props.updateEditProductDetail([
            ...data.responseData,
            {
                key: 'accountMongoId',
                value: outletData[0] ? outletData[0].id : ''
            }
        ]);
        setDelivUpfrontData(data.upFrontData);
    }

    return (deliveryPermissions?.isVolumetricWeightEnabled ? <Fragment>
            <SectionLabel
                styles={props.styles} 
                title={`Delivery Profile${outletData && outletData.length > 1 ? 's': ''}`}
                subTitle={outletData && outletData.length ? outletData[0].selectedProfile : ''}
                onClick={() => setDelivSlider(true)} 
            />
            {showDelivSec ? 
                <DeliverySlider 
                    heading='Delivery Profile'
                    headerVariant='secondary'
                    onHidden={() => setDelivSlider(false)} 
                    onSubmit={(responseData, upFrontData) => saveHandler({responseData, upFrontData})} 
                    singleOutletAcc={outletData && outletData.length === 1}
                    productData={props.productData} 
                    deliveryIdPair={deliveryIdPair}
                    outletData={outletData}
                />
            : null}
        </Fragment> : null
    );

}
const mapStateToProps = (state,props) => {
    return {
        ...props,
        permissions: state.permissions
    }
}
export default connect(mapStateToProps, {
    updateEditProductDetail,
    showToastMessage
})(DeliveryProfileSection);